import React from "react";
import { Tag } from "antd";
import moment from "moment/moment";
import { type Blog } from "@/lib/@types/api/blog";
import { Link } from "@/navigation";
import { CalendarTwoTone } from "@ant-design/icons";
import CustomImage from "../Image";

interface BlogProps {
	news: Blog.BlogListItem;
  index?:number
}

const BlogItemDefault: React.FC<BlogProps> = ({ news,index }) => {
	return (
		<>
			<Link
				href={"/blog/" + news.blog_slug}
				className="border block transform cursor-pointer overflow-hidden  rounded-lg bg-white shadow-lg transition-all duration-700 hover:-translate-y-2 group"
			>
				<div className="relative w-full aspect-[3/2] overflow-hidden bg-gray-100">
					<CustomImage
						src={news.blog_cover_origin}
						alt={news.blog_title}
						className="object-cover"
						fill
						sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
					/>
				</div>

				<div className="px-4 py-6">
					{/* 分类标签 */}
					<div className="mb-3 flex gap-x-1 overflow-hidden">
						{news.blog_classification_list &&
							news.blog_classification_list.map((item) => {
								return (
									<Tag 
										color="" 
										className="bg-gray-100 text-xs uppercase text-black rounded-md border-0 px-2 py-1" 
										key={item.cls_slug}
									>
										{item.cls_name}
									</Tag>
								);
							})}
					</div>
					{/* 标题 */}
					<h3 className="mb-3 line-clamp-2 text-lg font-bold text-black h-[3.5rem] leading-7 group-hover:text-mainColor transition-colors duration-300">{news.blog_title}</h3>
					{/* 描述 */}
					{news.blog_excerpt && (
						<p className="mb-5 line-clamp-2 text-sm font-normal text-gray-500 leading-relaxed">
							{news.blog_excerpt}
						</p>
					)}
					{/* 底部元数据 */}
					<div className="flex items-center justify-between gap-x-1">
						<div className="flex items-center">
							<img 
								src="/image/plsyy/logo.png" 
								alt="blog avatar" 
								className="w-12 object-contain flex-shrink-0"
							/>
							{/* <span className="ml-2 text-sm text-black">{news.blog_author}</span> */}
						</div>
						<div className="flex items-center text-sm text-black">
							<CalendarTwoTone className="mr-1" />
							<span>{moment(news.publish_time).format("MMM DD YYYY")}</span>
						</div>
					</div>
				</div>
			</Link>
		</>
	);
};

export default BlogItemDefault;
